export default [
  {
    header: 'Dashboard',
    resource: 'APP.DASHBOARD',
    action: 'read',
  },
  {
    title: 'Anasayfa',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP.DASHBOARD',
    action: 'read',
  },
  {
    header: 'Trader',
    resource: 'coins.list',
    action: 'read',
  },
  {
    title: 'Coin Listesi',
    route: 'Coins',
    icon: 'DollarSignIcon',
    resource: 'coins.list',
    action: 'read',
  },
  {
    title: 'İndikatörler',
    route: 'Indicators',
    icon: 'ActivityIcon',
    resource: 'indicators.list',
    action: 'read',
  },
  {
    title: 'Performans',
    route: 'IndicatorPerformance',
    icon: 'BarChart2Icon',
    resource: 'indicators.list',
    action: 'read',
  },
  {
    title: 'Entry Router',
    route: 'EntryRouter',
    icon: 'GitBranchIcon',
    resource: 'indicators.list',
    action: 'read',
  },
  {
    title: 'Edge Library',
    route: 'Edges',
    icon: 'TargetIcon',
    resource: 'edges.list',
    action: 'read',
  },
  {
    title: 'Quick Gain',
    route: 'QuickGain',
    icon: 'ZapIcon',
    resource: 'edges.manage',
    action: 'read',
  },
  {
    title: 'Script Signal',
    route: 'ScriptSignal',
    icon: 'RadioIcon',
    resource: 'edges.manage',
    action: 'read',
  },
  {
    title: 'Filo',
    route: 'Fleet',
    icon: 'LayersIcon',
    resource: 'edges.manage',
    action: 'read',
  },
  {
    title: 'Kazanç Stratejileri',
    route: 'ProfitStrategies',
    icon: 'TrendingUpIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    title: 'Position Guardian',
    route: 'PositionGuardian',
    icon: 'ShieldIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    title: 'Strategy Doctor',
    route: 'StrategyDoctor',
    icon: 'ClipboardIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    title: 'Test Studio',
    route: 'TestStudio',
    icon: 'PlayCircleIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    title: 'Signal Launcher',
    route: 'SignalLauncher',
    icon: 'SendIcon',
    resource: 'bots.list',
    action: 'read',
  },
  {
    title: 'Signal Automation',
    route: 'SignalAutomation',
    icon: 'SlidersIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    title: 'Hedge Pair Trading',
    route: 'HedgePairTrading',
    icon: 'ShuffleIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    title: 'Rescan Jobs',
    route: 'RescanJobs',
    icon: 'RefreshCwIcon',
    resource: 'edges.list',
    action: 'read',
  },
  {
    title: 'Botlar',
    route: 'Bots',
    icon: 'CpuIcon',
    resource: 'bots.list',
    action: 'read',
  },
  {
    title: 'Hedefler',
    route: 'Targets',
    icon: 'FlagIcon',
    resource: 'targets.list',
    action: 'read',
  },
  {
    header: 'Raporlar Bölümü',
    resource: 'reports.list',
    action: 'read',
  },
  {
    title: 'Raporlar',
    route: 'Reports',
    icon: 'BarChart2Icon',
    resource: 'reports.list',
    action: 'read',
  },
  {
    title: 'Finans',
    route: 'Finance',
    icon: 'CreditCardIcon',
    resource: 'reports.list',
    action: 'read',
  },
  {
    header: 'Hesap',
    resource: 'api-keys.list',
    action: 'read',
  },
  {
    title: 'API Anahtarları',
    route: 'ApiKeys',
    icon: 'KeyIcon',
    resource: 'api-keys.list',
    action: 'read',
  },
  {
    header: 'Sistem',
    resource: 'audit-logs.list',
    action: 'manage',
  },
  {
    title: 'Konsol',
    route: 'SystemConsole',
    icon: 'TerminalIcon',
    resource: 'audit-logs.list',
    action: 'manage',
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'users.list',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'user-types.list',
        action: 'read',
      },
    ],
  },
]
